import React, { useState, useEffect, Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

function LoadMoreSkeleton() {
  return (
    <>
      {Array(8).fill().map((_, index) => (
        <div className="col-md-3 cardItem" style={{ padding: '5px' }} key={index}>
          <div className="cardItem-item">
            <div className="img-card imgCard">
              <Skeleton className='img-item' variant="rect" style={{ width: '100%', height: '100%' }} />
            </div>
            <div className="card-content" style={{ width: '100%' }}>
              <div className='title-card' style={{minHeight: 'auto'}}>
                <Skeleton style={{ height: '22px', width: '100%' }} />
                <Skeleton style={{ height: '22px', width: '90%' }} />
              </div>
              <div className="content-item">
                <Skeleton style={{ height: '22px', width: '40%' }} />
                <Skeleton style={{ height: '22px', width: '20%' }} />
              </div>
           
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center',  }}>
                <Skeleton style={{ height: '22px', width: '40%' }} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default LoadMoreSkeleton;